import React from "react";
import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

import { layoutTypes } from "../constants/layout";
import NonAuthLayout from "../Layout/NonAuthLayout";
import VerticalLayout from "../Layout/VerticalLayout";
import HorizontalLayout from "../Layout/HorizontalLayout";
import AuthProtected from "./AuthProtected";
import { authProtectedRoutes, publicRoutes } from "./routes";
import NotFound from "../Pages/NotFound"

// Function to dynamically select layout based on layoutType
const getLayout = (layoutType) => {
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      return VerticalLayout;
    case layoutTypes.HORIZONTAL:
      return HorizontalLayout;
    default:
      return VerticalLayout;
  }
};

const Index = () => {
  // Selector for layoutType from Redux store
  const routepage = createSelector(
    (state) => state.Layout,
    (state) => ({
      layoutType: state.layoutType,
    })
  );

  // Get layoutType from Redux store
  const { layoutType } = useSelector(routepage);

  // Dynamically select layout
  const Layout = getLayout(layoutType);

  return (
    <Routes>
      {/* Public Routes */}
      {publicRoutes.map((route, _id) => (
        <Route
          key={_id}
          path={route.path}
          element={
            <NonAuthLayout>
              {route.component}
            </NonAuthLayout>
          }
        />
      ))}

      {/* Auth Protected Routes */}
      {authProtectedRoutes.map((route, _id) => (
        <Route
          key={_id}
          path={route.path}
          element={
            <AuthProtected>
              <Layout>
                {route.component}
              </Layout>
            </AuthProtected>
          }
        />
        
      ))}
      
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Index;